import { slugify } from './functionalUtils';

const TEAM_MAP = {
  futafc: 'https://afc-eskilstuna.se/team/mMZnBZnN',
  futbor: 'https://www.baikfutsal.se/',
  futck: 'https://www.fckalmar.se',
  futfcre: 'https://www.svenskalag.se/fc-real-internacional',
  futgbg: 'http://www.ifkgoteborgfutsal.se/',
  futham: 'http://www.hammarbyfotboll.se/',
  futkutd: 'https://www.laget.se/kalmarunitedfk',
  futnor: 'https://www.svenskalag.se/norrkopingfutsal-herrar',
  futorefc: 'http://www.orebrofutsal.se/',
  futoresk: 'http://www.oskfutsal.se/',
  futsko: 'https://www.skoftebynfutsal.se/',
  futudd2: 'http://uddevallafutsal.se/',
  futsod: 'https://www.laget.se/soderfutsal',
};

export const getTeamUrl = (id) => TEAM_MAP[id?.toLowerCase()];

export const getPlayerUrl = (teamId, displayName) =>
  teamId && displayName
    ? `/lagen/${TEAM_MAP[teamId.toLowerCase()]}/${slugify(displayName)}`
    : '';

export const getMatchUrl = (season, matchId, homeTeamName, visitingTeamName) =>
  `/matcher/${season}/${matchId}/${slugify(homeTeamName)}-mot-${slugify(
    visitingTeamName
  )}`;
